import { observer } from "mobx-react-lite";
import React, { useState, FormEvent, useContext, useEffect } from "react";
import { RouteComponentProps } from "react-router";
import { Button, CheckboxProps, Dropdown, Form, Grid, Input, Segment } from "semantic-ui-react";
import { IProjectTime } from "../../../app/models/projecttime";
import ProjectTimeStore from "../../../app/stores/projecttimeStore";

const ProjectTimeCreateForm: React.FC<RouteComponentProps> = ({ history }) => {
  const projecttimeStore = useContext(ProjectTimeStore);
  const { createProjectTime, employeeByName, submitting} = projecttimeStore;

  const [newProjectTime, setNewProjectTime] = useState<IProjectTime>({
    id: "",
    createdAt: "",
    updatedAt: "",
    code: "",
    description: "",
    type: '',
    startTime: "",
    endTime: "",
    lunch: 0,
    penaltyRate: "1",
    weekendRate: "1",
    nightRate: "1",
    reviewerEmail: '',
    remark: "",
  });

  const handleSubmit = () => {
    createProjectTime(newProjectTime).then(() => {
      history.push(`/hrmanagement/projecttimes`);
    });
  };

  const handleInputChange = (
    event: FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.currentTarget;
    setNewProjectTime({ ...newProjectTime, [name]: value });
  };

  const employeeOptions = employeeByName.map(function (emp) {
    var option = { "key": emp.id, "text": emp.name, "value": emp.email }
    return option;
  }
  );

  const type = [{ key: "Daily", text: "Daily", value: "Daily" },
  { key: "Hourly", text: "Hourly", value: "Hourly" }];

  return (
    <Segment clearing>
      <Form onSubmit={handleSubmit}>
        <Form.Input
          label="Project Code"
          required
          onChange={handleInputChange}
          name="code"
          placeholder="Project Code"
          value={newProjectTime.code}
        />
        <Form.Input
          label="Description"
          onChange={handleInputChange}
          name="description"
          placeholder="Description"
          value={newProjectTime.description}
        />
        <Form.Select
            label="Type"
            required
            onChange={(e, { name, value }) =>
             setNewProjectTime({ ...newProjectTime, [name]: value })
            }
            name="type"
            placeholder="Type"
            options={type}
            value={newProjectTime.type}
        />
        {(newProjectTime.type === 'Hourly') && 
         <Form.Group widths="equal">
         <Form.Input
            label="Start Time"
            onChange={handleInputChange}
            name="startTime"
            type="time"
            placeholder="Start Time"
            value={newProjectTime.startTime}
         /> 
         <Form.Input
            label="End Time"
            onChange={handleInputChange}
            name="endTime"
            type="time"
            placeholder="End Time"
            value={newProjectTime.endTime}
         /> 
         <Form.Input
          label="Lunch Time(minutes)"
          onChange={handleInputChange}
          name="lunch"
          placeholder="Lunch Time"
          type='number'
          value={newProjectTime.lunch}
         />
         </Form.Group>}
         <Form.Input
          label="Overtime Rate"
          onChange={handleInputChange}
          name="penaltyRate"
          placeholder="Overtime Rate"
          value={newProjectTime.penaltyRate}
        />
        <Form.Input
          label="Weekend Rate"
          onChange={handleInputChange}
          name="weekendRate"
          placeholder="Weekend Rate"
          value={newProjectTime.weekendRate}
        />
        <Form.Input
          label="Night Shift Rate"
          onChange={handleInputChange}
          name="nightRate"
          placeholder="Night Shift Rate"
          value={newProjectTime.nightRate}
        />
        <Form.Select
          label="Reviewer"
          placeholder='Select Reviewer'
          options={employeeOptions} 
          search
          name='reviewerEmail'
          onChange={(e, {name, value}) => setNewProjectTime({ ...newProjectTime, [name]: value })}
          value={newProjectTime.reviewerEmail}
        />
        <Form.Input
          label="Remark"
          onChange={handleInputChange}
          name="remark"
          placeholder="Remark"
          value={newProjectTime.remark}
        />
        <Button
          loading={submitting}
          floated="right"
          positive
          type="submit"
          content="Submit"
        />
        <Button
          onClick={() => history.push("/hrmanagement/projecttimes")}
          floated="right"
          type="button"
          content="Cancel"
        />
      </Form>
    </Segment>
  );
};

export default observer(ProjectTimeCreateForm);
